import { useEffect, useState } from "react";
import axios from "../axios";

export const useTodayZeroLessons = () => {
  const [todayLessons, setTodayLessons] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStudents = async () => {
      try {
        const { data: students } = await axios.get("students/all");
        const today = new Date().toLocaleString("en-US", { weekday: "long" }).toLowerCase();
         
        const filtered = students.filter(
          (student) =>
            student.totalLessons === 0 &&
            student.classSchedule.some((sch) => sch.day === today) && student.isPaused === false);
        
        const mapped = filtered.flatMap((student) =>
          student.classSchedule
            .filter((s) => s.day === today)
            .map((s) => ({
              name: student.name,
              time: s.time,
              teacher: student.teacherName,
              teacherId: student.teacherId,
              accessType: student.accessType,
            }))
        );

        setTodayLessons(mapped);
      } catch (err) {
        console.error("Failed to fetch students:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchStudents();
  }, []);

  return { todayLessons, loading };
};
